import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useCart } from "../../components/cart/cartProvider";

const stripeSecretKey = process.env.REACT_APP_PUBLISHABLE_KEY;
const REACT_APP_WEB_URL = process.env.REACT_APP_WEB_URL;
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REACT_APP_BACKEND_API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

const stripePromise = loadStripe(stripeSecretKey);

function CheckoutForm ({email, addressLine1,addressLine2, city, state, zip, phone, deliveryDate, deliveryToggle, addOns}) {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false);
    const [deliveryCheck, setDeliveryCheck] = useState(false);
    const {clearCart, generateCartJson} = useCart();
    const [isLoading, setIsLoading] = useState(false);
    console.log(deliveryToggle);
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true)
        if (!isChecked) {
            alert("Please agree to the terms and conditions before submitting.");
            return;
        }

        if (deliveryToggle && !deliveryCheck) {
            alert("Please agree to delivery terms before submitting.");
            return;
        }

        if (!stripe || !elements) {
            return;
        }
        const shippingAddress = (addressLine1+addressLine2+city+state+zip).length<1?"Pickup":`${addressLine1}, ${addressLine2 ? addressLine2 + ", " : ""}${city}, ${state}, ${zip}`;
        
        console.log("Payment Submitted");

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${REACT_APP_WEB_URL}payment_success`,
            },
            redirect: "if_required",
        });

        if (error) {
            setIsLoading(false);
            navigate(`/cart?error=${encodeURIComponent(error.message)}`);
        } else {
            const confirmPayment = async (payment_intent_id) => {
                console.log("confirmPayment triggered with payment_intent_id:", payment_intent_id);
                const products = generateCartJson();
                const orderData = {
                    data: {
                        customer_email: email,
                        shipping_address: shippingAddress,
                        payment_intent: payment_intent_id,
                        phone_number: phone,
                        delivery_date: deliveryDate,
                        products: products
                    }
                }
                try {
                  const response = await fetch(`${REACT_APP_BACKEND_URL}confirm-payment`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'x-api-key': REACT_APP_BACKEND_API_KEY,
                    },
                    body: JSON.stringify(orderData),
                  });
              
                  const responseData = await response.json();
                  
                  if (responseData.status===201) {
                    console.log("Payment confirmed");
                    setIsLoading(false);
                    clearCart();
                    return responseData.order_id;
                  } else {
                    setIsLoading(false);
                    console.error("Error:", responseData);
                  }
                } catch (error) {
                    setIsLoading(false);
                  console.error("Request failed:", error);
                }
            };
            const orderID = await confirmPayment(paymentIntent.id);
            navigate(`/payment_success?order_id=${encodeURIComponent(orderID)}`);
        }
    }

    return (
        <form className="mt-3" onSubmit={handleSubmit} style={{fontSize: "clamp(1em, 2vw, 1.5em)"}}>
            <PaymentElement/>
            <div class="form-check d-flex flex-column">
                <div className="mx-auto">
                    <input className="form-check-input ms-auto" type="checkbox" id="flexCheckDefault" required checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}/>
                    <label class="form-check-label me-auto px-1" for="flexCheckDefault">
                        Agree to <a target="_blank" rel="noopener noreferrer" href={REACT_APP_WEB_URL+"terms_and_agreement"} onClick={(e) => e.stopPropagation()}>Terms and Conditions Agreement</a> 
                    </label>
                </div>
                

                {deliveryToggle && <div className="mx-auto"><input className="form-check-input ms-auto" type="checkbox" id="flexCheckDefault" required checked={deliveryCheck} onChange={(e) => setDeliveryCheck(e.target.checked)}/>
                <label class="form-check-label me-auto px-1" for="flexCheckDefault">
                    <a>All deliveries arrive by 5:30 PM CST on your selected date. Please confirm!</a> 
                </label></div>}
            </div>
            <div className="d-flex m-3">
            <button className="btn btn-primary mx-auto" disabled={isLoading}>
                {isLoading ? (
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    'Complete Purchase'
                )}
            </button>
            </div>
        </form>
    );
}

function PaymentModal ({clientSecret, show, handleClose,email, addressLine1,addressLine2, city, state, zip, phone, deliveryDate,deliveryToggle, addOns}) {

    const options = {clientSecret}

    return (
        <div className="container-fluid ">
            {
            clientSecret && (
                <Elements stripe={stripePromise} options={options}>
                    <CheckoutForm 
                        email={email} 
                        addressLine1={addressLine1} 
                        addressLine2={addressLine2} 
                        city={city} state={state} 
                        zip={zip} phone={phone} 
                        deliveryDate={deliveryDate}
                        handleClose={handleClose}
                        deliveryToggle={deliveryToggle}
                        addOns={addOns}
                    />
                </Elements>
            ) }
        </div>
    );
}

export default PaymentModal;